module.exports = __webpack_public_path__ + "img/about.63c424fd.png";